import { forEach, isElement } from "lodash";
import mustache from "mustache";

import { get as getPageOptions } from "../../01-helpers/utilities/options";

import getPlaces from "../../03-api/autocomplete/get-places";

import Autocomplete from "../../04-components/autocomplete/";
import containerManager from "../../01-helpers/filter-context/container-manager";

const moduleName = "places",
  selectors = {
    base: `.js-autocomplete-${moduleName}`,
    northeast: `.js-autocomplete-northeast`,
    southwest: `.js-autocomplete-southwest`,
  },
  translationsKey = {
    key: "translations",
  },
  templateCityList = `
        {{#cities}}
            <li>
				<button class="c-search-box__result js-autocomplete-list-item" data-autocomplete='{"boundingBox": [{{ BoundingBox.NorthEast.Latitude }},{{ BoundingBox.NorthEast.Longitude }},{{ BoundingBox.SouthWest.Latitude }},{{ BoundingBox.SouthWest.Longitude }}], "center": [{{ Center.Latitude }},{{ Center.Longitude }}]}' type="button">{{ Name }} - {{ FullName }}</button>
			</li>
        {{/cities}}
	`;

export class PlaceSearch extends Autocomplete {
  constructor(baseElement) {
    super(baseElement);
    this.northeast = baseElement.querySelector(selectors.northeast);
    this.southwest = baseElement.querySelector(selectors.southwest);
    this.translations = getPageOptions(translationsKey.key);
  }

  renderTemplate(data) {
    const cities = {
        cities: data,
      },
      htmlTemplate = mustache.render(templateCityList, cities);

    return htmlTemplate;
  }

  resetFilter() {
    this.filterContext.update(
      {
        SearchQuery: "",
        SearchBox: null,
      },
      { refresh: true },
    );
  }

  /*================ EVENT HANDLERS ===============*/

  /**
   * Handler for Click event on ListItem
   *
   * @param {any} evt - Click (Mouse) event
   */
  _onItemClickHandler(evt) {
    const target = evt.currentTarget || evt.target,
      dataset = JSON.parse(target?.dataset?.autocomplete);

    this.input.value = target.innerText;

    if (isElement(this.northeast) || isElement(this.southwest)) {
      this.northeast.value = `${dataset.boundingBox[0]},${dataset.boundingBox[1]}`;
      this.southwest.value = `${dataset.boundingBox[2]},${dataset.boundingBox[3]}`;
    }

    const action = this.baseElement.getAttribute("action") || "/trainingen/";
    const currentPath = window.location.pathname;
    const isOnFilterablePage = currentPath.includes(action);

    if (!isOnFilterablePage) {
      const filterData = {
        f: [],
        p: 1,
        q: this.input.value,
        bb: dataset.boundingBox,
        c: dataset.center,
      };

      window.location.href = action + "#" + btoa(JSON.stringify(filterData));
      return;
    }

    const radiusDropdown = this.baseElement.querySelector(
      "select.c-search-box__dd",
    );
    const searchRadius = radiusDropdown ? parseInt(radiusDropdown.value) : 5000;

    const filterData = {
      SearchQuery: this.input.value,
      SearchRadius: searchRadius,
      SearchRadiusInMeters: String(searchRadius),
      NodeId: this.NodeId,
      Page: this.Page,
    };

    const bb = dataset.boundingBox;
    if (
      bb &&
      bb[0] != null &&
      bb[1] != null &&
      bb[2] != null &&
      bb[3] != null
    ) {
      filterData.SearchBox = {
        NorthEast: { Latitude: bb[0], Longitude: bb[1] },
        SouthWest: { Latitude: bb[2], Longitude: bb[3] },
      };
    }

    const c = dataset.center;
    if (c && c[0] != null && c[1] != null) {
      filterData.Center = { Latitude: c[0], Longitude: c[1] };
    }

    this.filterContext.update(filterData, { refresh: true });

    this.input.dataset.autofill = true;
    this.closeContainer();
  }

  _onKeyUpHandler(evt) {
    this.input.dataset.autofill = false;
    const element = evt.target,
      value = element.value;

    if (value.length >= 3) {
      const data = {
        query: value,
      };

      getPlaces(data)
        .done((results) => {
          this.list.innerHTML = "";

          this.list.innerHTML = this.renderTemplate(results);
          this._setClickEvent(this.list);
        })
        .fail((error) => {
          console.error(this.translations[translationsKey.CityCourseError]);
        });
    } else if (value.length == 0) {
      this.resetFilter();
    }
  }
}

const initPlaceSearch = () => {
  forEach(document.querySelectorAll(selectors.base), (baseElement) => {
    new PlaceSearch(baseElement);
  });
};

// Initialize
initPlaceSearch();
